import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { AuthProvider } from './auth/AuthContext.tsx';
import App from './App.tsx';
import './index.css';

// autoUpdate mode activates a new service worker as soon as it's found, but
// only checks for one on its own polling schedule — without this, a tab left
// open (or reopened from cache) can keep serving a stale build indefinitely.
registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (registration) setInterval(() => registration.update(), 60 * 60 * 1000);
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
